module.exports = __webpack_public_path__ + "img/dorm-absence.ae48988d.png";